import React from 'react';
import PropTypes from 'prop-types';
import HeaderWithBreadcrumbs from '../../componentsV2/Headers/HeaderWithBreadcrumbs';
import { DialogsProvider, ToastProvider } from '../../providers';
import { withContextProvider } from '../../hoc';
import ReportsPageWrapper from '../../componentsV2/Exports/ReportsPageWrapper';

const ReportsPage = ({ organizationId }) => {
  return (
    <DialogsProvider>
      <div className="mx-2.75">
        <header>
          <HeaderWithBreadcrumbs links={[{ href: '/reports', name: 'Reports' }]} name="reports" label="Reports" />
        </header>
        <main>
          <ReportsPageWrapper organizationId={organizationId} />
        </main>
      </div>
    </DialogsProvider>
  );
};

ReportsPage.propTypes = {
  organizationId: PropTypes.number.isRequired,
};

export default withContextProvider(ToastProvider)(ReportsPage);
